<script lang="ts" setup="">
import type { RelatedDocumentData } from '~/utils/crystallize/component-schemas'
import { NuxtLink } from '#components'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'

const props = defineProps<{
  data: RelatedDocumentData
}>()

const { data: product } = useProduct(() => props.data.path)

const card = useProductCard(product)
</script>

<template>
  <div class="py-l px-m bg-blurple-100 rounded-2xl flex gap-xl items-center">
    <CrystallizeImage :image="product?.components?.illustration" class="hidden md:block size-32" />
    <div class="flex flex-col gap-xs">
      <h4 v-if="product?.components?.tittel" v-text="product?.components?.tittel" />
      <p v-if="product?.components?.subtitle" v-text="product?.components?.subtitle" />
      <div v-if="card?.variant || card?.href" class="mt-s flex gap-s flex-wrap">
        <Button :is="NuxtLink" v-if="card?.href" :to="card?.href" variant="tertiary" size="small" :icon="faArrowRight" icon-position="right">
          Les&nbsp;mer
        </Button>
      </div>
    </div>
  </div>
</template>
